import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useReactiveVar } from '@apollo/client'
import { Box, makeStyles } from '@material-ui/core'
import { projectVar } from '../../apollo/reactive-vars'
import { CarbonFootprintSideBarContent } from '../carbon-footprint/CarbonFootprintSideBarContent'
import { getEmissionModel } from '../../emission-coefficients/emission-coefficients'
import { ProjectSubLayoutBase } from './ProjectSubLayoutBase'
import { Loader } from '../common/Loader'
import {
  ProjectSubLayoutProps,
  ProjectSubLayoutParams,
} from './ProjectSubDataLayout'
import { CommentsButton } from '../comments/CommentsButton'
import { CommentLocationType } from '../../generated/graphql'
import { CarbonFootprintMenu } from '../carbon-footprint/CarbonFootprintMenu'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}))

export function CarbonFootprintLayout({
  children,
}: ProjectSubLayoutProps): React.ReactElement {
  const { t } = useTranslation()
  const classes = useStyles()
  const { id } = useParams<ProjectSubLayoutParams>()
  const project = useReactiveVar(projectVar)

  if (!project) {
    return <Loader />
  }

  const pathPrefix = `/projects/${id}/carbonfootprint`

  const tabs = [
    {
      id: 'carbon-footprint-table-tab',
      title: t('carbonFootprint.tabs.table'),
      path: pathPrefix,
    },
    {
      id: 'carbon-footprint-results-tab',
      title: t('carbonFootprint.tabs.results'),
      path: `${pathPrefix}/results`,
    },
  ]

  return (
    <ProjectSubLayoutBase
      title={t('carbonFootprint.title')}
      sidebarContent={
        <CarbonFootprintSideBarContent
          emissionModel={getEmissionModel(project)}
        />
      }
      menu={
        <Box className={classes.container}>
          <CommentsButton locationType={CommentLocationType.CarbonFootprint} />
          <CarbonFootprintMenu projectName={project.name} />
        </Box>
      }
      tabs={tabs}
    >
      {children}
    </ProjectSubLayoutBase>
  )
}
